var path = 'app/scripts/modules/google/src/pipeline/stages/findImageFromTags/findImageFromTagsStage.html';
var html = "<div ng-controller=\"gceFindImageFromTagsStageCtrl as findImageFromTagsCtrl\" class=\"form-horizontal\">\n  <stage-config-field label=\"Package\">\n    <input type=\"text\" class=\"form-control input-sm\"\n           ng-model=\"stage.packageName\"/>\n  </stage-config-field>\n  <stage-config-field label=\"Tags\">\n    <map-editor model=\"stage.tags\" allow-empty=\"true\"></map-editor>\n  </stage-config-field>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/google/src/pipeline/stages/findImageFromTags/findImageFromTagsStage.html
// module id = 1330
// module chunks = 0